var _rect, _path, _g, _rect2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifyEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#6C79A2"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_4872)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_735_4872",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H49V49H15V15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_735_4872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1051 40.0529C48.1051 41.0021 47.728 41.9124 47.0568 42.5836C46.3856 43.2548 45.4753 43.6318 44.5261 43.6318H19.4735C18.5243 43.6318 17.614 43.2548 16.9428 42.5836C16.2716 41.9124 15.8945 41.0021 15.8945 40.0529V23.9476C15.8945 22.9984 16.2716 22.0881 16.9428 21.4169C17.614 20.7457 18.5243 20.3687 19.4735 20.3687H44.5261C45.4753 20.3687 46.3856 20.7457 47.0568 21.4169C47.728 22.0881 48.1051 22.9984 48.1051 23.9476V40.0529Z",
    fill: "#CCD6DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5865 31.6743L16.4643 41.7965C16.4402 41.8215 16.4312 41.8528 16.4106 41.8779C16.7141 42.3871 17.1397 42.8127 17.649 43.1162C17.6749 43.0956 17.7053 43.0867 17.7295 43.0634L27.8525 32.9395C28.0203 32.7716 28.1145 32.5439 28.1144 32.3066C28.1143 32.0692 28.02 31.8416 27.8521 31.6739C27.6842 31.5061 27.4565 31.4119 27.2192 31.412C26.9818 31.4121 26.7543 31.5064 26.5865 31.6743Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5886 41.8779C47.5698 41.8528 47.5591 41.8215 47.535 41.7974L37.4137 31.6743C37.3306 31.5912 37.232 31.5252 37.1234 31.4802C37.0149 31.4352 36.8985 31.412 36.781 31.412C36.6635 31.4119 36.5471 31.435 36.4385 31.48C36.3299 31.5249 36.2312 31.5908 36.1481 31.6739C36.065 31.7569 35.999 31.8556 35.954 31.9641C35.909 32.0727 35.8858 32.1891 35.8857 32.3066C35.8857 32.4241 35.9088 32.5405 35.9537 32.6491C35.9987 32.7577 36.0646 32.8563 36.1476 32.9395L46.2698 43.0625C46.294 43.0867 46.3253 43.0956 46.3503 43.1162C46.86 42.8133 47.2857 42.3875 47.5886 41.8779Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5261 20.3685H19.4735C18.5243 20.3685 17.614 20.7456 16.9428 21.4168C16.2716 22.088 15.8945 22.9983 15.8945 23.9475V24.869L28.8933 37.8383C29.7115 38.6524 30.8187 39.1094 31.973 39.1094C33.1272 39.1094 34.2344 38.6524 35.0526 37.8383L48.1051 24.8503V23.9475C48.1051 22.9983 47.728 22.088 47.0568 21.4168C46.3856 20.7456 45.4753 20.3685 44.5261 20.3685Z",
    fill: "#99AAB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.526 20.3686H19.4734C18.7999 20.3701 18.1405 20.562 17.5714 20.9222C17.0022 21.2824 16.5465 21.7961 16.2568 22.4041L29.4685 35.6167C29.8009 35.9491 30.1954 36.2127 30.6296 36.3926C31.0639 36.5725 31.5293 36.665 31.9993 36.665C32.4693 36.665 32.9347 36.5725 33.3689 36.3926C33.8032 36.2127 34.1977 35.9491 34.53 35.6167L47.7426 22.4041C47.453 21.796 46.9973 21.2822 46.4282 20.9221C45.859 20.5619 45.1996 20.37 44.526 20.3686Z",
    fill: "#E1E8ED"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#4BD6B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2698 16.8785C36.5986 17.2073 36.5986 17.7405 36.2698 18.0694L31.2171 23.122C30.8883 23.4509 30.3551 23.4509 30.0262 23.122L27.7296 20.8254C27.4007 20.4965 27.4007 19.9633 27.7296 19.6345C28.0584 19.3056 28.5916 19.3056 28.9205 19.6345L30.6217 21.3357L35.0788 16.8785C35.4077 16.5496 35.9409 16.5496 36.2698 16.8785Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_4872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verify-email.64346fd12e70c277abeaf44ecb39d26d.svg";
export { ForwardRef as ReactComponent };